import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    cursor: 'pointer',
  },
}));

export default useStyles;
